/**
 * Maintenance Page - Shown when system is in maintenance mode
 * Roblox-inspired "OH NOES" style
 */
import React from 'react';
import { Box, Button, Container, Typography, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useMaintenance } from '../context/MaintenanceContext';

export default function Maintenance() {
  const navigate = useNavigate();
  const { maintenanceMessage } = useMaintenance();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #2d5016 0%, #3d6b1e 50%, #4a8025 100%)',
        p: 2,
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={24}
          sx={{
            p: { xs: 3, sm: 5 },
            textAlign: 'center',
            background: '#ffffff',
            borderRadius: 4,
            border: '6px solid #ff6600',
          }}
        >
          {/* Roblox-style maintenance image */}
          <Box
            component="img"
            src="/maintenance.png"
            alt="OH NOES - Maintenance"
            sx={{
              width: '100%',
              maxWidth: 500,
              height: 'auto',
              borderRadius: 2,
              mb: 3,
              boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
            }}
          />

          <Typography
            variant="h3"
            sx={{
              fontWeight: 900,
              color: '#1a1a1a',
              textTransform: 'uppercase',
              letterSpacing: 3,
              mb: 2,
            }}
          >
            System Maintenance
          </Typography>

          <Typography
            variant="h6"
            sx={{
              color: '#444',
              mb: 3,
              maxWidth: 600,
              mx: 'auto',
            }}
          >
            {maintenanceMessage || 
              "We're performing scheduled maintenance on Ranger Vault. The system will be back online shortly."}
          </Typography>

          <Box
            sx={{
              bgcolor: '#fff3cd',
              border: '2px solid #ffc107',
              borderRadius: 2,
              p: 2,
              mb: 4,
              maxWidth: 500,
              mx: 'auto',
            }}
          >
            <Typography variant="body1" sx={{ color: '#856404', fontWeight: 600 }}>
              🚧 Only the Dashboard is available during maintenance.
            </Typography>
            <Typography variant="body2" sx={{ color: '#856404', mt: 1 }}>
              Rangers can still update their status and create incidents.
            </Typography>
          </Box>

          <Button
            variant="contained"
            size="large"
            onClick={() => navigate('/dashboard')}
            sx={{
              bgcolor: '#ff6600',
              color: 'white',
              fontWeight: 800,
              fontSize: '1.1rem',
              px: 5,
              py: 1.5,
              '&:hover': {
                bgcolor: '#e55b00',
              },
            }}
          >
            🚗 Go to Dashboard
          </Button>

          <Box sx={{ mt: 4, pt: 3, borderTop: '2px dashed #ddd' }}>
            <Typography variant="caption" sx={{ color: '#888', display: 'block' }}>
              🤠 Texas Highway Rangers - We'll be back on the road soon!
            </Typography>
            <Typography
              variant="caption"
              sx={{ color: '#888', fontFamily: 'monospace', mt: 1, display: 'block' }}
            >
              Status: MAINTENANCE_MODE_ACTIVE
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
